import { useEffect, useState } from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import SignUpForm from './SignUpForm';
import SignupMarketingPanel from './SignupMarketingPanel';

function isTrafficSignupSource(): boolean {
  const params = new URLSearchParams(window.location.search);
  return params.get('utm') === 'traffic' || params.get('utm_source') === 'traffic';
}

function ApplyTrial() {
  const [formFirst, setFormFirst] = useState(false);

  useEffect(() => {
    setFormFirst(isTrafficSignupSource());
  }, []);

  return (
    <div className="signup-page">
      <div className={`signup-page-grid${formFirst ? ' signup-page-grid--form-first' : ''}`}>
        <div className="signup-page-form-col">
          <SignUpForm variant="card" />
          <p className="signup-page-security-note">
            <ShieldCheckIcon className="signup-page-security-icon" aria-hidden />
            Your data is encrypted in transit. We never share it with third parties.
          </p>
        </div>

        <SignupMarketingPanel className="signup-page-marketing" />
      </div>
    </div>
  );
}

export default ApplyTrial;
